

export const REQUESTED_BUCKET_ROLL = 'REQUESTED_BUCKET_ROLL'
export const RECEIVED_BUCKET_ROLL = 'RECEIVED_BUCKET_ROLL'
export const ERROR_BUCKET_ROLL = 'ERROR_BUCKET_ROLL'

export const receivedBucketRoll = (bucketRollData) => ({
  type: RECEIVED_BUCKET_ROLL,
  bucketRollData
});

export const requestedBucketRoll = () => ({
  type: REQUESTED_BUCKET_ROLL
});

export const errorBucketRoll = (error) => ({
  type: ERROR_BUCKET_ROLL,
  error
});